// TODO@tyler: What if we have 100 merits and 1 verification request?
export const MAX_NOTIFICATIONS_BEFORE_HIDING = 100;
